import { lazy } from 'react';
import styled from 'styled-components';

import { Color } from '../../../constants/Colors';
import { FontWeight } from '../../../constants/Fonts';
import { MediaQuery, Transition } from '../../../constants/Styles';

const Text = lazy(() => import('../../../../ui/Atoms/Text'));

export const WordcloudWrapper = styled.div`
  justify-content: center;
  align-items: center;
  width: 800px;
  height: 400px;
  margin: auto;
  background: #f4f8ff;
  border: 10px solid #ffffff;
  box-shadow: 0px 15px 30px rgba(20, 106, 255, 0.05);
  border-radius: 60px;

  ${MediaQuery.M_AND_DOWN} {
    width: auto;
    max-height: 350px;
  }

  ${MediaQuery.S_AND_DOWN} {
    height: 250px;
  }
`;

export const InputWrapper = styled.div`
  position: relative;
  caret-color: ${Color.BLUE_DODGER};
  margin: 0 10px 0 0;

  ${MediaQuery.M_AND_DOWN} {
    margin: 0 0 10px 0;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 150px;
  opacity: ${({ isVisible }) => (isVisible ? '1' : '0')};
  transition: ${Transition.OPACITY_EASE};

  ${MediaQuery.L_AND_DOWN} {
    margin-bottom: 100px;
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;

  p {
    font-size: 28px;
    font-weight: ${FontWeight.REGULAR};
    color: ${Color.CLOUD_BURST};
    margin-right: 15px;
  }

  ${MediaQuery.M_AND_DOWN} {
    flex-flow: wrap;
    margin-bottom: 10px;
    justify-content: flex-start;
    text-align: center;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: 20px;

  ${MediaQuery.M_AND_DOWN} {
    flex-direction: column;
    margin: 0 60px 10px 60px;
  }
`;

export const Title = styled(Text)``;
